// extracted by mini-css-extract-plugin
export var layoutContainer = "_ad-0";
export var layoutContainerNoRounding = "_ad-6";
export var layoutContainerOpen = "_ad-5";
export var layoutContainerResizing = "_ad-1";
export var mainContent = "_ad-2";
export var resizeDivider = "_ad-3";
export var slidePanel = "_ad-4";